import $ from 'jquery';

const defaults = {
  source: '.field-image.c1 img',
};

function ImageBackgrounds($elements, options) {
  this.$elements = $elements;
  this.settings = { ...defaults, ...options };
  this.addBackgroundsToElements();
}

ImageBackgrounds.prototype = {
  addBackgroundsToElements() {
    this.$elements.each((i, element) => {
      // Grabs the src of the first main image.
      const src = $(this.settings.source, element).attr('src');
      // Applies a background image to the passed element.
      $(element).css('background-image', `url("${src}")`);
    });
  },
};

export default ImageBackgrounds;



// WEBPACK FOOTER //
// ./ImageBackgrounds.js